import React from 'react'
import './Part1.css'
function Part1() {
    return (
        <div className="part1">

           <div className="part1-sub-text-container">
              
                <p className="part1-sub-text">موفقیت بستگی به میزان تمایل هر شخصی در پیشرفت دارد</p>   

            </div>
        
            <div className="part1-text-container">

                <h1 className="part1-text">توسعه و پیشرفت کسب و کار خود را در دنیای دیجیتال به ما بسپارید</h1>    
    
            </div>
    
            <div className="part1-buttons-container">

                <a href="#contact-us" className="btn btn--black part1-black-btn">ارتباط با ما</a>

                <a href="#special-options" className="btn btn--white part1-white-btn">آپشن های خاص </a>
                

            </div>

            <div className="scroll-animation-container">

                <a href="#Part2" class="container">
                  <div class="chevron"></div>
                  <div class="chevron"></div>
                  <div class="chevron"></div>
                </a>

            </div>

        </div>
    )
}

export default Part1



// WEBPACK FOOTER //
// ./src/components/Part1/Part1.js